module.exports = __webpack_public_path__ + "img/21.018f851.png";